<template>
  <div>
    <!-- <SearchPannel @search="getList" /> -->
    <div class=" mb-20">
      <OrderItem v-for="i in list" :key="i.orderCode" :is-list-item="true" :info="i" class="mt-20" @cancelSuccess="cancelSuccess" />
    </div>
    <div v-if="pagination.totalSize>0" class="pl-20 pr-20 pb-20 t-right">
      <a-pagination v-model="pagination.pageIndex" :page-size="pagination.pageSize" :total="pagination.totalSize" show-less-items @change="onChange" />
    </div>
    <div v-else class="ant-table-placeholder"><div class="ant-empty ant-empty-normal"><div class="ant-empty-image"><svg width="64" height="41" viewBox="0 0 64 41" xmlns="http://www.w3.org/2000/svg"><g transform="translate(0 1)" fill="none" fillRule="evenodd"><ellipse fill="#F5F5F5" cx="32" cy="33" rx="32" ry="7" /><g fillRule="nonzero" stroke="#D9D9D9"><path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z" /><path d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z" fill="#FAFAFA" /></g></g></svg></div><p class="ant-empty-description">暂无数据</p></div></div>
  </div>
</template>
<script>
// import SearchPannel from './searchPannel'
import OrderItem from './orderItem'
export default {
  components: {
    OrderItem
  },
  data() {
    return {
      params: {
        // 'endCreateDate': this.$moment().format('YYYY-MM-DD'),
        // 'startCreateDate': this.$moment().format('YYYY-MM-DD'),
        status: 1
      },
      list: [],
      pagination: {
        'pageIndex': 1,
        'pageSize': 3,
        totalSize: 0
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    cancelSuccess() {
      this.pagination.pageIndex = 1
      this.getList()
    },
    async getList(params) {
      if (params) {
        Object.assign(this.params, params)
      }
      this.params.pageIndex = this.pagination.pageIndex
      this.params.pageSize = this.pagination.pageSize
      const res = await this.$http(this.$api.orderGetPageList, { ...this.params, orderOrigin: 2 })
      if (res) {
        this.list = res.list || []
        this.pagination.pageIndex = res.pageIndex
        this.pagination.pageSize = res.pageSize
        this.pagination.totalSize = res.totalSize
        this.$emit('count', res.totalSize)
      }
    },
    onChange(pageIndex) {
      this.pagination.pageIndex = pageIndex
      this.getList()
    }
  }
}
</script>
